import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

interface IContactPageDataResult {
  fetch: {
    Common: {
      Contact: {
        BackgroundColor: string | null;
        TitleColor: string | null;
      } | null;
      Partners: {
        Email: string | null;
      } | null;
    };
    Country: {
      ContactPage: {
        Header: string | null;
        ContactEmail: string | null;
        Content: string | null;
        SendText: string | null;
        ShowContactButton: string | null;
      } | null;
    };
  };
}

interface IVariables {
  filters: {
    UrlKey: string;
  };
}

interface IRequiredProps {
  country: string;
}

export interface IWithContactPageQueryProps {
  contactQuery: QueryResult<IContactPageDataResult>;
}

class ContactPageQuery extends Query<IContactPageDataResult, IVariables> {}

const withContactPageQuery = <P extends IWithContactPageQueryProps>(
  Component: React.ComponentType<P>
): React.SFC<
  Subtract<P, IWithContactPageQueryProps> & IRequiredProps
> => props => {
  const { country } = props;
  return (
    <ContactPageQuery
      query={queries.GET_CONTACT_PAGE_DATA}
      variables={{
        filters: { UrlKey: country }
      }}
    >
      {providedProps => (
        <Component contactQuery={providedProps} {...props as any} />
      )}
    </ContactPageQuery>
  );
};

export default withContactPageQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withContactPageQuery.tsx